<template>
  <div class="antiMoneyLaunderingQuery">
    <van-form label-width="120px">
      <van-field
        v-model="content.TSHPZH"
        :label="$t.antiMoneyLaundering.tshpzh"
        disabled
      />

      <van-field
        v-model="content.CASE_ID"
        :label="$t.antiMoneyLaundering.caseId"
        disabled
      />

      <van-field
        v-model="content.UserName"
        :label="$t.antiMoneyLaundering.qPeople"
        disabled
      />

      <van-field
        v-model="content.CreateTime"
        :label="$t.antiMoneyLaundering.qDate"
        disabled
      />

      <van-field
        :value="
          content.QUERY_RESULT == 2
            ? $t.antiMoneyLaundering.antiOption2
            : $t.antiMoneyLaundering.antiOption1
        "
        :label="$t.antiMoneyLaundering.queryResult"
        disabled
      />

      <div class="custom-field" v-if="content.QUERY_RESULT == 2">
        <div class="custom-field-label">
          {{ $t.antiMoneyLaundering.antiView }}
        </div>
        <div class="custom-field-value">
          <van-button
            size="small"
            type="info"
            @click="openLink(content.WarringViewUrl)"
            >{{ $t.meta.view }}</van-button
          >
        </div>
      </div>

      <div
        class="list-container"
        v-for="(item, index) in content.SacnList"
        :key="index"
      >
        <div class="list-item">
          {{ $t.antiMoneyLaundering.name }}：{{ item.NAME }}
        </div>
        <div class="list-item">
          {{ $t.antiMoneyLaundering.identityNum }}：{{ item.IDENTITYNUM }}
        </div>
        <div class="list-item">
          {{ $t.antiMoneyLaundering.country }}：{{ item.COUNTRY }}
        </div>
        <div class="list-item">
          {{ $t.antiMoneyLaundering.attribute }}：<span
            v-if="item.BLACK_TYPE == 1"
            >{{ $t.antiMoneyLaundering.antiOption2 }}</span
          ><span v-else>{{ $t.antiMoneyLaundering.antiOption1 }}</span>
        </div>
      </div>
    </van-form>
  </div>
</template>
<script>
import Vue from "vue";
import { Form, Field, Button, Icon, Image } from "vant";

Vue.use(Form).use(Field).use(Button).use(Icon).use(Image);

export default {
  name: "antiMoneyLaunderingQuery",
  data() {
    return {
      AMLId: "",
      content: {},
    };
  },
  created() {
    const { AMLId, Content } = this.$route.query;
    if (AMLId) {
      this.AMLId = AMLId;
      this.getAntiMoneyLaunderingListQueryResult();
    } else {
      this.content = JSON.parse(Content);
    }
  },
  methods: {
    openLink(url) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.gotoPay, {
        url: url,
      });
    },
    getAntiMoneyLaunderingListQueryResult() {
      return new Promise((resolve, reject) => {
        this.$commonMethod.showLoading();
        var param = {
          AMLId: this.AMLId,
        };
        this.$api.marketRisk
          .getAntiMoneyLaunderingListQueryResult(param)
          .then((res) => {
            this.content = res.data;
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(
              this.$commonEnv.actionType.showDialog,
              {
                msg: error.message,
              }
            );
            reject();
          });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.antiMoneyLaunderingQuery {
  ::v-deep .number-label {
    line-height: 33px;
  }
  ::v-deep .van-field--disabled {
    .van-field__label,
    .van-field__control {
      color: #323233 !important;
      -webkit-text-fill-color: #323233 !important;
    }
  }
  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }
  .van-cell::after {
    border: none !important;
  }
  .custom-field {
    font-size: 14px;
    padding: 12px 16px;
    border-bottom: 1px solid #ebedf0;
    .custom-field-label {
      width: 120px;
      font-size: 14px;
      margin-right: 12px;
      color: #323233;
      display: inline-block;
      vertical-align: middle;
    }
    .custom-field-value {
      width: 50%;
      display: inline-block;
      vertical-align: middle;
    }
  }
  .list-container {
    font-size: 12px;
    color: #333;
    margin-top: 10px;
    padding: 10px;
    box-shadow: 0px 2.5px 5px 2.5px rgba(0, 0, 0, 0.2);
    .list-item {
      margin-bottom: 10px;
      width: 50%;
      display: inline-block;
    }
    .list-item:nth-last-child(2) {
      margin-bottom: 0px;
    }
    .list-item:last-child {
      margin-bottom: 0px;
    }
  }
}
</style>
